import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { Delete, List, MoreVert, PictureAsPdf } from '@mui/icons-material';
import { ListItemIcon, ListSubheader } from '@mui/material';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function CowpageMenu({ handlePdf, handleClean, show,  ImportContent, CatalogInit, ExportCSV }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const clickPdf = (p) => {
        handleClose()
        handlePdf(p)

    }


    return (
        <div>
            <Button
                id="cow-button"
                aria-controls={open ? 'cow-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant={open ? 'contained' : "outlined"}
                disableElevation
                onClick={handleClick}

            >
                <MoreVert />
            </Button>
            <StyledMenu
                id="cow-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <ListSubheader>stampa PDF</ListSubheader>
                <MenuItem disabled={!show} onClick={() => clickPdf('p')} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Pettorali
                </MenuItem>
                <MenuItem disabled={!show} onClick={() => clickPdf('c')} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Cartelli
                </MenuItem>
                <Divider />
                <ListSubheader>gestione soggetti</ListSubheader>
                <ImportContent />
                <CatalogInit />
                <MenuItem disabled={!show} onClick={() => handleClean()} disableRipple>
                    <ListItemIcon>
                        <Delete />
                    </ListItemIcon>
                    Elimina tutti i soggetti
                </MenuItem>
                <ListSubheader>altro</ListSubheader>
                <MenuItem disabled={!show} onClick={() => clickPdf('g')} disableRipple>
                    <ListItemIcon>
                        <List />
                    </ListItemIcon>
                    Visualizzazioni raggruppate
                </MenuItem>
            </StyledMenu>
        </div>
    );
}